module.exports = {"nav":{"langChange":"Смени езика","lang":"Език","translate":"Превеждай"},"txt":{"close":"Затваряне"}};